export default "__VITE_ASSET__D1sDS3K5__"